module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-marie-sophie.1dcca728.jpeg";